import { Visibility } from '@mui/icons-material';
import { Formik } from 'formik';

import { Flex } from 'src/components/Flex';
import { DropDown } from 'src/components/FormikComponents';
import { CreditNoteStatus } from 'src/constants';
import { getEnumDropDownOptions } from 'src/utils/utils';
import { AllocatePaymentValidation } from 'src/validation/SalesInvoice';

import { CancelCreditNoteItem, ResendCreditNoteItem } from './components';
interface CallToActionsProps {
    billingContactEmailAddress: string;
    onAllocatePayment?: () => void;
    onView: () => void;
    creditNote: {
        salesInvoice: {
            status: string;
        };
        totalCreditAmount: number;
    };
}

const CallToActions = ({ billingContactEmailAddress, onView, creditNote }: CallToActionsProps) => {
    // TODO: Get the correct statuses when the ticket for the functionality gets created
    const statusOptions = getEnumDropDownOptions(CreditNoteStatus);

    return (
        <Flex alignItems="center" gap="8px">
            <Formik
                onSubmit={async ({ totalCreditAmount, balance, status }) => {
                    // TODO : to create actions for call to action buttons
                }}
                initialValues={{
                    status: creditNote?.salesInvoice?.status,
                    balance: creditNote?.totalCreditAmount,
                    totalCreditAmount: creditNote?.totalCreditAmount,
                }}
                // TODO: validation schema for credit note statuses
                validationSchema={AllocatePaymentValidation}
                enableReinitialize
            >
                {() => <DropDown name="status" options={statusOptions} />}
            </Formik>
            <CancelCreditNoteItem />
            <Flex
                justifyContent="center"
                alignItems="center"
                color="white"
                bgcolor="#F39E4E"
                borderRadius="4px"
                padding="8px"
                sx={{ cursor: 'pointer' }}
                onClick={onView}
            >
                <Visibility height="24px" width="24px" />
            </Flex>
            <ResendCreditNoteItem billingContactEmailAddress={billingContactEmailAddress} />
        </Flex>
    );
};
export default CallToActions;
